import { createContext, PropsWithChildren, useReducer } from "react";

import { TextAction } from "@/pages/sources/components/create/sources/text/actions";
import createSourceTextReducer from "@/pages/sources/components/create/sources/text/reducer";
import {
  CreateSourceTextState,
  TextPhase,
} from "@/pages/sources/components/create/sources/text/types";

export interface SourceTextContextShape {
  state: CreateSourceTextState;
  dispatch: React.Dispatch<TextAction>;
}

export const DEFAULT_STATE: CreateSourceTextState = {
  sourceName: "",
  textContent: "",
  shouldShowErrors: false,
  phase: TextPhase.IDLE,
  error: null,
};

export const SourceTextContext = createContext<SourceTextContextShape | null>(null);
SourceTextContext.displayName = "SourceTextContext";

const SourceTextProvider = ({ children }: PropsWithChildren) => {
  const [state, dispatch] = useReducer(createSourceTextReducer, DEFAULT_STATE);

  return (
    <SourceTextContext.Provider value={{ state, dispatch }}>{children}</SourceTextContext.Provider>
  );
};

export default SourceTextProvider;
